import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { I18nModule, UrlModule } from '@spartacus/core'
import { IconModule, MediaModule, SearchBoxComponentService } from '@spartacus/storefront'
import { EbSpinnerModule } from '../../../../components/spinner/eb-spinner.module'
import { EbSearchBoxComponent } from './eb-search-box.component'
import { EbHighlightPipe } from './ebHighlight.pipe'
import { EbSearchBoxComponentService } from './services/eb-search-box-component.service'

@NgModule({
  declarations: [EbSearchBoxComponent, EbHighlightPipe],
  exports: [EbSearchBoxComponent],
  imports: [
    CommonModule,
    RouterModule,
    MediaModule,
    IconModule,
    UrlModule,
    I18nModule,
    EbSpinnerModule
  ],
  providers: [
    {
      provide: SearchBoxComponentService,
      useClass: EbSearchBoxComponentService
    }
  ]
})
export class EbSearchBoxModule {}
